var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-page"},[_vm._m(0),_vm._v("\n  "+_vm._s(this.message)+"\n")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fp-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png")}})])
}]

export { render, staticRenderFns }